import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { JobHttpService } from 'cms/features/feature_job/service';
import { BaseHttpService } from 'cms/core/services';
import { HttpService } from 'core/services/http';
import { Utils } from 'core/utils';
import CompanyEditModal from '../components/CompanyEditModal';
import CompanyProfileCard from '../components/CompanyProfileCard';
import CompanyHeader from '../components/CompanyHeader';
import CompanyNavMenu from '../components/CompanyNavMenu';
import CompanyStatisticsWidget from '../components/CompanyStatisticsWidget';
import {
    Box,
    Container,
    CircularProgress,
    Alert
} from '@mui/material';

function MyCompanyPage() {
    const [editModalOpen, setEditModalOpen] = useState(false);
    const queryClient = useQueryClient();

    const { data: company, isLoading, isError, error } = useQuery(
        'myCompany',
        () => JobHttpService.loadMyCompany(),
        {
            retry: 1,
            onError: (err) => {
                console.error('Error loading company:', err);
            }
        }
    );

    // Auto-open edit modal if no company exists
    useEffect(() => {
        if (!isLoading && !company && !isError) {
            setEditModalOpen(true);
        }
    }, [isLoading, company, isError]);

    const handleEditClick = () => {
        setEditModalOpen(true);
    };

    const handleModalClose = () => {
        setEditModalOpen(false);
    };

    const handleCompanySaved = () => {
        queryClient.invalidateQueries('myCompany');
        setEditModalOpen(false);
    };


    return (
        <Box sx={{ bgcolor: 'grey.50', minHeight: '100vh' }}>
            {/* Company Header */}
            {/* <CompanyHeader /> */}

            <Container maxWidth="lg" sx={{ py: 4 }}>
                {isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                )}

                {isError && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error?.message || 'Failed to load company information'}
                    </Alert>
                )}

                {!isLoading && !isError && (
                    <>
                        {/* Company Profile Card */}
                        <Box sx={{ mb: 4 }}>
                            <CompanyProfileCard 
                                company={company} 
                                onEditClick={handleEditClick}
                            />
                        </Box>

                        {/* Navigation Menu */}
                        <Box sx={{ mt: 4 }}>
                            <CompanyNavMenu />
                        </Box>

                        {/* Company Statistics Widget */}
                        {company?.id && (
                            <CompanyStatisticsWidget companyId={company.id} />
                        )}

                        
                    </>
                )}

                {/* Edit Modal */}
                <CompanyEditModal
                    open={editModalOpen}
                    onClose={handleModalClose}
                    company={company}
                    onSaved={handleCompanySaved}
                />
            </Container>
        </Box>
    );
}

export default MyCompanyPage;

